/* eslint-disable */

'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.card-residence').length <= 0 ) {
        return
    }

    const swiperInstances= {}
    $('.card-residence__slider').each( function(i, el) {
        const $this = $(this)
        const id    = $this.data('id')

        swiperInstances[id] = new Swiper(`.card-residence__slider-${id}`, {
            init: false,
            slidesPerView: 1,
            speed: 500,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        })
    })

    $('.card-residence').hover(
        function () {
            const id = $(this).find('.card-residence__slider').data('id')
            if ('undefined' !== typeof id) {
                swiperInstances[id].init()
            }
        }
    )
}
